import { createStore } from "vuex";
import {
  clearAuthStorage,
  loadStoredUser,
  persistAuthSession,
  useSessionCookie,
} from "@/config/session";
import { resetWebConfigCache } from "@/config/loadWebConfig";
import { API_BASE_URL, fetchWithTimeout } from "@/config/apiBase";

export default createStore({
  state: {
    isTransparent: "",
    isRTL: false,
    isAbsolute: false,
    showSidenav: true,
    isSidenavCollapsed: false,
    user: loadStoredUser(),
    menuAccess: [],
    featureAccess: [],
  },
  mutations: {
    toggleEveryDisplay(state) {
      state.showSidenav = !state.showSidenav;
    },
    setShowSidenav(state, visible) {
      state.showSidenav = !!visible;
    },
    toggleSidenavCollapsed(state) {
      state.isSidenavCollapsed = !state.isSidenavCollapsed;
    },
    setAuthenticatedUser(state, user) {
      state.user = user;
    },
    setUser(state, payload) {
      const user = payload?.user ?? payload;
      const token = payload?.token;
      state.user = user;
      if (user) {
        persistAuthSession(user, token);
      } else {
        if (useSessionCookie()) {
          fetchWithTimeout(`${API_BASE_URL}/api/auth/logout`, { method: "POST" }).catch(() => {});
        }
        clearAuthStorage();
        resetWebConfigCache();
        state.menuAccess = [];
        state.featureAccess = [];
      }
    },
    setMenuAccess(state, rows) {
      state.menuAccess = Array.isArray(rows) ? rows : [];
    },
    setFeatureAccess(state, keys) {
      state.featureAccess = Array.isArray(keys) ? keys : [];
    },
  },
  getters: {},
});
